document.addEventListener("DOMContentLoaded", function () {
    function updateIframePlacement() {
        const mobileTourRoute = document.querySelector(".mobile-tour-route");
        const targetElement = document.querySelector(".bg-svgs.svg-header-slideshow");
        const existingIframe = document.querySelector("iframe[data-tour-route]");
        
        if (!mobileTourRoute || !targetElement) return;
        
        const mapLink = mobileTourRoute.getAttribute("data-map-link");
        if (!mapLink) return;
        
        let iframe;
        if (existingIframe) {
            iframe = existingIframe;
        } else {
            iframe = document.createElement("iframe");
            iframe.src = mapLink;
            iframe.setAttribute("data-tour-route", "true");
        }
        
        if (window.innerWidth < 1250) {
            if (iframe.parentElement !== mobileTourRoute) {
                mobileTourRoute.insertBefore(iframe, mobileTourRoute.firstChild);
            }
        } else {
            let newDiv = document.querySelector(".tour-route-desktop");
            if (!newDiv) {
                newDiv = document.createElement("div");
                newDiv.className = "tour-route-desktop";
                targetElement.appendChild(newDiv);
            }
            if (iframe.parentElement !== newDiv) {
                newDiv.appendChild(iframe);
            }
        }
    }
    
    updateIframePlacement();
    
    const resizeObserver = new ResizeObserver(() => {
        updateIframePlacement();
    });
    
    resizeObserver.observe(document.body);
});
